import {
  LayoutDashboard, SlidersHorizontal, Zap, LineChart, Settings2,
  UserCog, Bot, Info, Camera, Images, Mail, UserCircle, Video,
} from "lucide-react";

export const TABS = [
  { id: "dashboard",  label: "Dashboard",  icon: LayoutDashboard },
  { id: "controls",   label: "Controls",   icon: SlidersHorizontal },
  { id: "energy",     label: "Energy",     icon: Zap },
  { id: "grafana",    label: "Grafana",    icon: LineChart },
  { id: "settings",   label: "Settings",   icon: Settings2 },
  { id: "personalize",label: "Personalize",icon: UserCog },
  { id: "ai",         label: "AI Chat",    icon: Bot },
  { id: "roboface",   label: "AI Face Call",icon: Video },
  { id: "about",      label: "About",      icon: Info },
  { id: "camera",     label: "Camera",     icon: Camera },
  { id: "gallery",    label: "Gallery",    icon: Images },
  { id: "contact",    label: "Contact",    icon: Mail },
  { id: "profile",    label: "Profile",    icon: UserCircle },
];

export const DEFAULT_SETTINGS = {
  mqttHost: "eeb1e83a06da4b44b7a340bc19cd1e75.s1.eu.hivemq.cloud",
  mqttUser: "cput_energy",
  mqttPass: "Hnk@2026",
  grafanaUrl: "https://ed219383693.grafana.net/d/edssbx8/campus-energy-monitor",
  geminiKeys: "AIzaSyAEdfvBnlug6zO0qP0M4X5gDlqkuLapr4A\nAIzaSyCZkLcZN9DzAd_E5w4X2baq15YotJqyJ-o\nAIzaSyCdHkAJySADhrRXl3VnAtir5EtBYzWDq90\nAIzaSyCdAjRatkq7MgnBChxyjzdpldtmAe8DUR0",
  deepseekKey: "sk-c52c23d38917441f8ff087301c56cd39",
  voiceEngine: "elevenlabs",
  elevenKey: "sk_174dfc7221169c653cd7ceb18ad98c02d62b20bd2df14469",
  elevenVoiceId: "21m00Tcm4TlvDq8ikWAM",
  azureKey: "4l40LFcFEwuKEc4UjvqcWE329Ia6sTKjcQjYdMhNRt9nOG9MO2LdJQQJ99CFACrIdLPXJ3w3AAAYACOGzvyl",
  azureRegion: "southafricanorth",
  azureVoice: "en-US-JennyNeural",
  voicerssKey: "b1910ac67ca74230a707fd292bd47e35",
  voicerssLang: "en-us",
  voicerssVoice: "Linda",
  speechRate: 1,
  // personalize
  pirHold: 30,
  pirBrightness: 80,
  fan30: 36,
  fan60: 44,
  fan100: 52,
  fanCritical: 65,
  ledSchedule: false,
  ledOn: "18:00",
  ledOff: "06:00",
  ledDays: ["Mon", "Tue", "Wed", "Thu", "Fri"],
  camAutoFlash: true,
  camPirSnap: true,
  rapidInterval: 5,
  emailReports: false,
  emailTo: "hhnk3693@gmail.com",
  emailFreq: "daily",
  emailTime: "08:00",
  alertTemp: true,
  alertPower: true,
  alertGas: false,
  alertGasVal: 600,
  alertMqtt: true,
};
